import SearchIcon from "@mui/icons-material/Search";
import {
  IconButton,
  InputBase,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";

class SearchWidget extends Component {
  state = {
    searchTarget: "posts",
    query: "",
  };

  componentDidMount() {
    const { query, searchTarget } = this.props;
    const obj = {};
    if (query) {
      obj.query = query;
    }
    if (searchTarget) {
      obj.searchTarget = searchTarget;
    }
    this.setState(obj);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { searchTarget, query } = this.state;
    if (query != "" && searchTarget != "") {
      const params = new URLSearchParams();
      params.append("q", query);
      params.append("target", searchTarget);
      this.props.history.push({
        pathname: "/search",
        search: params.toString(),
      });
    }
  };

  render() {
    const { searchTarget, query } = this.state;
    return (
      <Fragment>
        <form onSubmit={this.handleSubmit} style={{ ...this.props.style }}>
          <ToggleButtonGroup
            value={searchTarget}
            onChange={(event, nextView) => {
              if (nextView.length) {
                this.setState({
                  searchTarget: nextView,
                });
              }
            }}
            exclusive
            fullWidth
          >
            <ToggleButton
              sx={{
                fontFamily: "inherit",
                padding: "5px",
              }}
              value="posts"
              size="small"
            >
              Posts
            </ToggleButton>
            <ToggleButton
              value="users"
              sx={{
                fontFamily: "inherit",
                padding: "5px",
              }}
              size="small"
            >
              Users
            </ToggleButton>
          </ToggleButtonGroup>
          <Paper
            sx={{
              p: "2px 4px",
              paddingLeft: "15px",
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <InputBase
              fullWidth
              variant="standard"
              placeholder="Search OuMedia"
              style={{
                fontFamily: "inherit",
              }}
              value={query}
              onChange={(e) => {
                this.setState({
                  query: e.target.value,
                });
              }}
            />
            <IconButton
              onClick={this.handleSubmit}
              disabled={query.trim().length == 0}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </form>
      </Fragment>
    );
  }
}

export default withRouter(SearchWidget);
